import { gsap } from 'gsap'

import { useNuxtApp } from '#imports'
import { useLayoutStore } from '~/store/layout'
import { useRouteStore } from '~/store/route'

function beforeEnter (el) {
  const route = useRouteStore()

  if (route.shouldTransition) {
    gsap.killTweensOf(el)

    gsap.set(el, {
      opacity: 0,
      // y: 50,
      transition: 'none'
    })
  }
}

function enter (el, done) {
  const route = useRouteStore()
  const { bus } = useNuxtApp()

  if (!route.shouldTransition) {
    done()
    bus.emit('page:enter')
  } else {
    gsap.timeline({
      onComplete: () => {
        gsap.set(el, { clearProps: 'all' })
        bus.emit('page:enter')
      }
    })
      .to(el, {
        opacity: 1,
        duration: 0.5
      })
      .add(done)
  }
}

function afterEnter () {
  const layout = useLayoutStore()
  const { bus } = useNuxtApp()
  layout.transitioning = false

  bus.emit('scroll:start')
  bus.emit('scroll:refresh')
  bus.emit('page:after-enter')
}

function beforeLeave () {
  const layout = useLayoutStore()
  const route = useRouteStore()
  const { bus } = useNuxtApp()

  if (route.shouldTransition) {
    layout.transitioning = true
    bus.emit('scroll:stop')
  }
}

function leave (el, done) {
  const route = useRouteStore()
  const { bus } = useNuxtApp()

  if (!route.shouldTransition) {
    done()
    bus.emit('page:leave')
  } else {
    gsap.killTweensOf(el)
    gsap.timeline({ onComplete: () => bus.emit('page:leave') })
      .to(el, {
        opacity: 0,
        duration: 0.3
      })
      .add(done)
  }
}

function afterLeave () {
  const route = useRouteStore()
  const { bus } = useNuxtApp()

  if (route.shouldTransition) {
    bus.emit('scroll:scroll-to', { target: 'top', options: { immediate: true, lock: true } })
  }

  bus.emit('page:after-leave')
}

export default {
  onBeforeEnter: beforeEnter,
  onEnter: enter,
  onAfterEnter: afterEnter,

  onBeforeLeave: beforeLeave,
  onLeave: leave,
  onAfterLeave: afterLeave
}
